import { render, staticRenderFns } from "./RedeemedTransactions.vue?vue&type=template&id=54c7767b&scoped=true"
import script from "./RedeemedTransactions.vue?vue&type=script&lang=js"
export * from "./RedeemedTransactions.vue?vue&type=script&lang=js"
import style0 from "./RedeemedTransactions.vue?vue&type=style&index=0&id=54c7767b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c7767b",
  null
  
)

export default component.exports